module.exports = __webpack_public_path__ + "static/media/canvas-tiles.fad254f8.png";